var _path, _path2, _path3, _polygon, _polygon2, _path4, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLensFeature1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1179",
    viewBox: "0 0 682.67 682.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m430.51,169.18v189.03h95v-189.03h31.82l-75.13-90.9h-8.38l-75.13,90.9h31.82Zm47.5-77.8l54.74,66.23h-18.82v189.03h-71.85v-189.03h-18.82l54.74-66.23Z",
    style: {
      fill: "#1A5AB1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.31,358.22h95v-183.04h-95v183.04Zm11.58-171.47h71.85v159.89h-71.85v-159.89Z",
    style: {
      fill: "#1A5AB1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.83,204.87h-95v153.34h95v-153.34Zm-11.58,141.77h-71.85v-130.19h71.85v130.19Z",
    style: {
      fill: "#1A5AB1"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m623.72,519.5H48.95c-14.58,0-26.44-11.86-26.44-26.44v-61.72h-11.58v61.72c0,20.96,17.06,38.02,38.02,38.02h574.77c20.96,0,38.02-17.06,38.02-38.02v-61.72h-11.58v61.72c0,14.58-11.86,26.44-26.44,26.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.93,412.04v11.58h497.11v-11.58H22.5V56.05c0-14.58,11.86-26.44,26.44-26.44h97.11v-11.58H48.95c-20.96,0-38.02,17.06-38.02,38.02v355.99Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m623.72,18.03H173.07v11.58h450.65c14.58,0,26.44,11.86,26.44,26.44v355.99h-115.11v11.58h126.69V56.05c0-20.96-17.06-38.02-38.02-38.02Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "409.11 568.79 413.73 591.86 425.54 591.86 420.46 566.52 409.11 568.79"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.2 566.52 247.13 591.86 258.93 591.86 263.55 568.79 252.2 566.52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m180.19,599.58v67.27h312.28v-67.27H180.19Zm300.7,55.7H191.77v-44.12h289.13v44.12Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 272.02,
    y: 465.77,
    width: 11.58,
    height: 11.58
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 387.78,
    y: 465.77,
    width: 11.58,
    height: 11.58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 329.9,
    y: 465.77,
    width: 11.58,
    height: 11.58
  })), /*#__PURE__*/React.createElement("rect", {
    x: 472.1,
    y: 275.76,
    width: 11.58,
    height: 11.58,
    style: {
      fill: "#1A5AB1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.09,
    y: 275.76,
    width: 11.58,
    height: 11.58,
    style: {
      fill: "#1A5AB1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.41,
    y: 275.76,
    width: 11.58,
    height: 11.58,
    style: {
      fill: "#1A5AB1"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensFeature1);
export default __webpack_public_path__ + "static/media/lens-feature-1.c6a5a3016c658019e092df9bb41aaf53.svg";
export { ForwardRef as ReactComponent };